import { ID } from "@project/shared-types";
import { apiPostWithLogging } from "../../api/apiHelpers";

const ADMIN_EXECUTOR_GET_URL = "/admin/executor/get";
const ADMIN_EXECUTOR_UNSET_JOB_URL = "/admin/executor/unset/job";
const ADMIN_EXECUTOR_UNSET_BAN_URL = "/admin/executor/unset/ban";

export const getExecutor = async (id: ID) =>
  apiPostWithLogging<{ id: ID }, any>(
    ADMIN_EXECUTOR_GET_URL,
    { id },
    "Ошибка при получении исполнителя:"
  );

export const unsetExecutorJob = async (id: ID) =>
  apiPostWithLogging<{ id: ID }, any>(
    ADMIN_EXECUTOR_UNSET_JOB_URL,
    { id },
    "Ошибка при снятии задания исполнителя:"
  );

export const unsetExecutorBan = async (id: ID) =>
  apiPostWithLogging<{ id: ID }, any>(
    ADMIN_EXECUTOR_UNSET_BAN_URL,
    { id },
    "Ошибка при снятии бана исполнителя:"
  );

